/* import __COLOCATED_TEMPLATE__ from './no-app-partner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();